/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faProcedures} from '@fortawesome/pro-duotone-svg-icons';

const HealthVisitIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faProcedures} {...props} />
);

export default HealthVisitIcon;
